import { render, staticRenderFns } from "./e-btn-language.vue?vue&type=template&id=5124f75b&scoped=true"
import script from "./e-btn-language.vue?vue&type=script&lang=js"
export * from "./e-btn-language.vue?vue&type=script&lang=js"
import style0 from "./e-btn-language.vue?vue&type=style&index=0&id=5124f75b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5124f75b",
  null
  
)

export default component.exports